<template>
		<div style="background-color:#F5F5F5;width:100%;">
			<div style="font-size:14px;display:flex;position: absolute;right:80px;">
				<a :href="url.blog" target="_blank"><div style="background-color:#50AEE1;" class="color">关注微博</div></a>
				<a :href="url.college" target="_blank"><div style="background-color:#5AD6CE;" class="color" >关注学院</div></a>
				<!-- <a :href="url.public" target="_blank"><div style="background-color:#6BD68C;" class="color">关注微信公众号</div></a> -->
				<div style="background-color:#6BD68C;cursor:pointer;" class="color" @click="topicture()">关注微信公众号</div>
			</div>
			<!-- logo -->
			<div style="width:100%;height:130px;background-color:white;">
				<div style="background-color:white;display:flex;">
					<div style="flex: 1;"></div>
					<div style="width:1400px;display:flex;">
						<div @click="fhsy">
							<img src="../assets/banner/logo.gif" class="logotou" />
						</div>
					</div>
					<div style="flex: 1;"></div>
				</div>
				<div style="position: absolute;right:80px;top: 60px;display: flex;">
					<input type="text" v-model="title"  style="outline:none;width:345px;;height:25px;border-style:solid; border-width:2px; border-color:#20919D;" />
					<div class="serch" @click="serchs()">搜索</div>
				</div>
				
				<!-- 搜索显示div -->
				<el-drawer
				@close="close()"
				  title="查询结果"
				  :visible.sync="drawer"
				  :with-header="false">
				  <div style="overflow-y:scroll;height:90%;">
					  <div  v-for="(item,index) in serchtitle" :key="index" style="margin-left:20px;">
					  	<div style="display: flex;margin-top:10px;align-items: center;">
					  		<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
					  		<div  class="divserch" @click="serchstz(item)">{{item.title}}</div>
					  	</div>	
					  </div>
				  </div>
				</el-drawer>
			</div>
			<!-- 导航栏 -->
			<div style="background-color:#20919D;height:56px;display:flex;">
				<div style="flex: 1;"></div>
				<div style="width:1200px;display:flex;">
					<div class="hovea" v-for="(item,index) in dh" :key="index"  @click="change(index)" >
						<div v-if="($store.state.navbg+1!=index)&&(index!=0&&index!=9)&&!(index==$store.state.navbg)" class="Line"></div>
						<div :class="$store.state.navbg==index&&$store.state.navbg!=7&&$store.state.navbg!=8?'dhls':'dhl'">{{item.a}}</div>
					</div>
				</div>
				<div style="flex: 1;"></div>
			</div>
			<!-- 轮播图 -->
			<div class="banner" style="width:100%;" v-if="($store.state.navbg==0)||($store.state.navbg==1)||
					($store.state.navbg==2)||($store.state.navbg==3)||($store.state.navbg==4)||($store.state.navbg==5)||
					($store.state.navbg==6)||($store.state.meetingbt==1)||($store.state.buslbt==1)">
				<el-carousel height="260px">
				  <el-carousel-item v-for="(item,index) in banners" :key="index">
					<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width:100%;height:260px;"></a>
					<a v-else><img :src="urls+item.url" style="width:100%;height:260px;cursor:pointer;"></a>
				  </el-carousel-item>
				</el-carousel>
			</div> 
			<!-- 主文 --> 
			<div>
				<div style="background-color:#F5F5F5;display: flex;align-items: center;justify-content: center;" >
					<div style="display:flex;justify-content: center;">
					<div style="background-color:#F5F5F5;display:flex;margin-top:10px;" v-if="($store.state.navbg==0)||($store.state.navbg==1)||
					($store.state.navbg==2)||($store.state.navbg==3)||($store.state.navbg==4)||($store.state.navbg==5)||
					($store.state.navbg==6)||($store.state.meetingbt==1)">
						<div style="background-color: #FFFFFF;width:240px;margin-left:10px;">
							<div v-for="(item,index) in tarhave" :key="index" >
								<div style="font-size:14px;text-align:left;color:#181818;font-weight:600;margin-top:16px;margin-left:16px;">{{item.name}}</div>
								<div style="display:flex;flex-wrap: wrap;padding-left:16px;margin-top:9px;">
									<div v-for="(itemtwo,index2) in ks" :key="index2" @click="tapone(index2)" >
											<div style="display: flex;" v-if="item.id == itemtwo.pid">
												<div class="zt kesa" :style="$store.state.id.data==itemtwo.id?'color:#20919D;':'color:#767676;'" >{{itemtwo.name}}</div>
												<div class="Lines"></div>
											</div>
									</div>
								</div>
								<div v-if="(index!=2)&&(index!=length-1)" style="background-color: #D1D1D1;height:1px;margin:5px 15px 0px 15px"></div>
								<div style="display:flex;margin-top:10px;" v-if="(index==2)">
									<div class="bodyd">
										<img style="width:30px;height: 30px;" :src="urls+weapon.url"></img>
										<div class="font" style="margin-top:5px;">创械圈</div>
									</div>
									<div class="bodyd">
										<img style="width:30px;height: 30px;" :src="urls+ideal.url"></img>
										<div class="font" style="margin-top:5px;">理实国际</div>
									</div>
									<div class="bodyd">
										<img style="width:30px;height: 30px;" :src="urls+school.url"></img>
										<div class="font" style="margin-top:5px;">学院</div>
									</div>
								</div>
							</div>
							 <div class="block" v-if="$store.state.navbg==0" style="margin-top:62.5px;">
							    <el-carousel height="76px" indicator-position="none">
							      <el-carousel-item v-for="(item,index) in bannertwo" :key="index">
							        <a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url"  style="width:240px;height: 76px;"/></a>
									<a v-else><img :src="urls+item.url"  style="width:240px;height: 76px;cursor:pointer;"/></a>
							      </el-carousel-item>
							    </el-carousel>
							  </div>
						</div>
					</div>
					<div><router-view ></router-view></div>
					</div>
					
				</div>
				
				<!-- 尾 -->
				<div class="font" style="display:flex;justify-content: center;color:#767676;margin-top:30px;padding-bottom:30px;" v-if="show==true">
					<div style="text-align: center;width:100%;">
					<div style="display: flex;justify-content: center;align-items: center;border-bottom: lightgrey solid 2px;">
						<router-link to='/Home/my'><p @click="tapthree()" style="color:#767676;">关于我们&emsp;|</p></p></router-link>
						<router-link to='/Home/About'><p @click="tapthree()" class="iur" style="color:#767676;">业务介绍&emsp;|</p></router-link>
						<router-link to='/Home/Business'><p @click="tapthrees()" class="iur" style="color:#767676;">产品中心&emsp;|</p></router-link>
						<router-link to='/Home/new_file'><p @click="tapthree()" class="iur" style="color:#767676;">招贤纳士</p></router-link>
					</div>
					<div style="display:flex;align-items: center;justify-content:center;margin-top:10px;">
						<div v-for="(item,index) in urlyqlj" :key="index">
							<a :href="item.url" target="_blank" ><div style="color:#767676;margin-left:10px;">{{item.name}}</div></a>
						</div>
					</div>
					<div style="display: flex;align-items: center;justify-content:center;">
						<div class="bjtop" style="display:flex;">
							<div >
								<img style="width:63px;height: 63px;" :src="urls+weapon.url"></img>
								<div class="font">创械圈</div>
							</div>
							<div class="bjleft">
								<img style="width:63px;height: 63px;" :src="urls+ideal.url"></img>
								<div class="font">理实国际</div>
							</div>
							<div class="bjleft">
								<img style="width:63px;height: 63px;" :src="urls+school.url"></img>
								<div class="font">学院</div>
							</div>
						</div>
						<div style="height:50px;background-color: #C1C1C1;width: 2px;margin-left:5px;"></div>
						<div class="bjleft" style="display:flex;flex-direction: column;margin-top:10px;">
							<div style="display:flex;align-items:center;justify-content: center;flex-direction: column;">
								<div style="display:flex;align-items: center;"><img src="../assets/beian.png">京公网安备 11010802034250号</div>
								<div style="display:flex;align-items: center;">备案号:京ICP备14030808号-5</div>
							</div>
							<div class="bjtop">TEL:010-84608511</div>
							<div class="bjtop">www.cn-imie.com</div>
						</div>
					</div>
					</div>
				</div>
			</div>
			
		</div>
</template>
<script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1279650506'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1279650506%26online%3D1' type='text/javascript'%3E%3C/script%3E"));</script>
<script type="text/javascript" src="https://v1.cnzz.com/z_stat.php?id=1279650506&web_id=1279650506"></script>
<script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1279650506'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1279650506' type='text/javascript'%3E%3C/script%3E"));</script>
<script>
	import { userRejister} from "../util/api.js";
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"Home",
		components:{
		},
		data() {
			return {
				title:'',
				serchtitle:[],//搜索文章
				drawer: false,//搜索弹出框
				ideal:'',//理实国际二维码
				weapon:'',//创械圏二维码
				school:'',//学院二维码
				pid:[],//一级id
				tabid:'',//二级id
				lengths:'',
				urls:'',
				length:'',
				tarhave:'',//一级文章
				ks:'',//二级文章
				banners:'',
				bannertwo:'',
				type:2,
				url:'',
				tabIndex:0,
				tabIndexs:0,
				show:true,
				urlyqlj:'',
				dh:[
					{a:'首页'},
					{a:'活动'},
					{a:'研究'},
					{a:'学院'},
					{a:'人物视界'},
					{a:'融资并购'},
					{a:'转移转化'},
					{a:'数据库'},
					{a:'会员'}
				],
			}
		},
		//监听路由
		watch:{
		    $route(to,from){
				  console.log(from.path);//从哪来
				  console.log(to.path);//到哪去
			  if(to.path=='/Home/page')
			  {
				  this.$store.commit("meetingshow",1)
				  this.$store.commit("navbgshow",0)
				  this.show=true
			  }
			  if(to.path=='/Home/Home/detailthree')
			  {
			  	this.show=false
			  }
			  if(to.path=='/Home/modify')
			  {
				this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/collgetwo')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/collegethree')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/collegefour')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/cardiovascular')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/Resource')
			  {
			  	this.$store.commit("meetingshow",1)
			  	this.$store.commit("navbgshow",5)
			  }
			  if(to.path=='/Home/details')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/meeting')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/Research')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/college')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/details')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/character')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/recommendation')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
			  if(to.path=='/Home/modifytwo')
			  {
			  	this.$store.commit("meetingshow",1)
			  }
		    }
		},
		created() {
			//二维数组meetingshow
			// var arr =[{name:'das',id:1},{name:'qwe',id:2},{name:'ewq',id:3}];
			// var arr1 =[{pid:1},{pid:1},{pid:2},{pid:2},{pid:3}];
			// arr.map((item,i)=>{
			// 	item.list=[];
			// 	arr1.map(items=>{
			// 		if(item.id==items.pid){
			// 			item.list.push(items);
			// 		}
			// 	})
				
			// })
			// console.log(arr);
			//友情链接
			axios({
			    url: `${base.url}/api/user/getUrl`,
			    method: 'post',
			    data:''
			}).then((res) => {
						if(res){
							this.urlyqlj=res.data
							console.log(this.urlyqlj);
						}
			        })
				//轮播图
			 userRejister({type:this.type}).then((res) => {
							 if(res){
								 // console.log(res);
								 this.banners=res.data
								 this.urls =res.url
							 }
					 })
				//首页分类轮播图
				axios({
				    url: `${base.url}/api/user/classBanner`,
				    method: 'post',
				    data:''
				}).then((res) => {
							if(res){
								this.bannertwo=res.data
							}
				        })		 
				 //获取系统信息
				 const data={
					 field:['blog','college','public','curriculum','books','weapon','ideal','school','character','character_src']
				 }
				 axios({
				     url: `${base.url}/api/user/getRule`,
				     method: 'post',
				     data:data
				 }).then((res) => {
					 this.url=res.data
					 this.ideal =res.data.ideal[0]
					 this.school =res.data.school[0]
					 this.weapon =res.data.weapon[0]
				         })
				//获取首页一级分类接口
				axios({
				    url: `${base.url}/api/user/homeOne`,
				    method: 'post',
				    data:''
				}).then((res) => {
							this.tarhave=res.data
							this.length=res.data.length
							//map循环添加元素到数组
							res.data.map(item=>{
								this.pid.push(item.id)
							})
							this.halou();
				        })
		},
		methods: {
			topicture(){
				this.$router.push({name:'picture'});
			},
			change:function(e){
				if(e!=this.$store.state.navbg){
					switch(e){
						case 0:
							this.$router.push({name:'Home'});
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							this.$store.commit("meetingshow",1)
							break;
						case 1:
							this.$router.push({name:'modifytwo'});
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							this.$store.commit("meetingshow",1)
							break;
						case 2:
							this.$router.push({name:'Research'});
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							this.$store.commit("meetingshow",1)
							break;
						case 3:
							this.$router.push({name:'college'});
							this.$store.commit("meetingshow",1)
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							break;
						case 4:
							this.$router.push({name:'character'});
							this.$store.commit("meetingshow",1)
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							break;
						case 5:
							this.$router.push({name:'Resource'});
							this.$store.commit("meetingshow",1)
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							break;
						case 6:
							this.$router.push({name:'recommendation'});
							this.$store.commit("meetingshow",1)
							this.$store.commit("liuxing",{data:0,type:this.tarhave,types:this.ks})
							break;	 				
					 }
				}
				if(e!=7&&e!=8){
					this.$store.commit("navbgshow",e)
				}
				 
		},
		changes:function(e){
				this.tabIndexs=e
		},
		tapthree:function(){
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",0)
			this.$store.commit("business",0)
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		tapthrees:function(){
			this.$store.commit("navbgshow",9)
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		fhsy:function(){
			this.$router.push({name:'page'});
			this.$store.commit("navbgshow",0)
		},
		//搜索全局文章
		serchs:function(){
			this.drawer=true
			//获取搜索文章接口
			axios({
			    url: `${base.url}/api/user/newList`,
			    method: 'post',
			    data:{title:this.title}
			}).then((res) => {
				if(res){
					//用数组解构出来在装入
					res.data.map((item)=>{
						this.serchtitle.push(...item)
						//数组
						// console.log(...item)
						// if(item.length==0){
						// 	console.log(111)
						// }else{
						// 	item.map(items=>{
						// 		this.serchtitle.push(items)
						// 	})
						// }
					})
				}
			        })
		},
		//搜索框清空
		close:function(){
			this.title=''
			this.serchtitle=[]
		},
		serchstz:function(e){
		this.$router.push({path:'/Home/details',query:{datasy:e}});
		this.drawer=false
		},
		halou:function(){
			//获取首页二级分类接口
			axios({
			    url: `${base.url}/api/user/homeTwo`,
			    method: 'post',
			    data:{pid:this.pid}
			}).then((res) => {
				if(res){
					this.ks=res.data
					this.lengths=res.data.length
				}
			        })
		},
		tapone:function(e){
			this.tabid=this.ks[e].id
			this.$store.commit("navbgid",this.tabid)
			this.$store.commit("navbgshow",9)
			// this.$router.push({name:'cardiovascular',params:{data:this.tabid,type:this.tarhave,types:this.ks}});
			this.$router.push({name:'cardiovascular'});
			this.$store.commit("liuxing",{data:this.tabid,type:this.tarhave,types:this.ks})
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		},
		components:{
		},
	}
</script>

<style lang="scss" scoped>
	body{
		width:100%;
		height:100%;
	}
	.divserch{
		margin-left:5px;
		text-align:left;
	}
	.divserch:hover{
	cursor:pointer;
	color:#20919D;
	}
	::-webkit-scrollbar {
	/*隐藏滚轮*/
	display: none;
	}
	.hovea{
		display:flex;
		align-items: center;
		position: relative;
	}
	.hovea:hover{
	cursor:pointer;
	background-color:#59D4CF;
	}
	.serchdiv{
		background-color: white;
		width:405px;
		position:absolute;
		right:50px;
		top:100px;
		border-radius:1px;
	}
	.dbgd{
		height:550px;
		background-color:red;
	}
	.logotou{
		height:120px;
		width:260px;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.bjmagin{
		margin:0px 10px 0px;
	}
	.bjmagins{
		margin:0px 10px 0px 0px;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.serch:hover{
		cursor:pointer;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		height:56px;
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.kesa{
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
	}
	.kesa:hover{
		cursor:pointer;
		color:#20919D !important;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.font{
		font-size:14px;
	}
	.colortm{
		font-size: 12px;
		opacity:0.2;
	}
	.fontcolor{
		color:#767676;
	}
	.has{
		background-color:#38A5EC;
		width:23px;
		height:2px;
		margin-top:5px;
		margin-left:10px;
	}
	.yerw{
		margin-left: 20px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.nmb{
		margin-top: 8px;
	}
	.nvbc{
		background-color:#20919D;
		width: 94px;
		height: 116px;
	}
	.ggnm{
		width:310px;
		height:76px;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
	.bodyd:hover{
	background-color:#5AD6CE;
	}
	.bodyd{
		background-color:#20919D;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
</style>
